import React, { useState, useEffect, useRef } from "react";

export function SymbolShiftPuzzle({ onFirstInteraction, onInteraction, onSolved }) {
  console.log("🛠 [CHECK] Puzzle est affiché à l'écran"); // Doit apparaître à l'ouverture de la modal
  const BASE = ["🔺", "🟦", "⚫", "⭐"];
  const SYMBOLS = BASE;
  const TARGET_ROW_2 = [BASE[2], BASE[3], BASE[0], BASE[1]];
  const TARGET_ROW_3 = [BASE[3], BASE[0], BASE[1], BASE[2]];

  const [interactiveRows, setInteractiveRows] = useState([
    ["🔺", "🔺", "🔺", "🔺"],
    ["🟦", "🟦", "🟦", "🟦"],
  ]);

  const startedRef = useRef(false);
  const solvedRef = useRef(false);

  const handleClickCell = (visualRowIndex, colIndex) => {
    if (visualRowIndex < 2 || solvedRef.current) return;

    if (!startedRef.current) {
      startedRef.current = true;
      console.log("🧩 [ENFANT] Première interaction détectée");
      onFirstInteraction?.();
    }

    onInteraction?.();

    const interactiveIndex = visualRowIndex - 2;
    setInteractiveRows((prev) => {
      const next = prev.map((row) => [...row]);
      const current = next[interactiveIndex][colIndex];
      const idx = SYMBOLS.indexOf(current);
      next[interactiveIndex][colIndex] = SYMBOLS[(idx + 1) % SYMBOLS.length];
      return next;
    });
  };

  // ✅ Détection de la victoire APRES le rendu des symboles
  useEffect(() => {
    if (solvedRef.current) return;

    const row2Ok = interactiveRows[0].every((s, i) => s === TARGET_ROW_2[i]);
    const row3Ok = interactiveRows[1].every((s, i) => s === TARGET_ROW_3[i]);

    if (row2Ok && row3Ok) {
      solvedRef.current = true;
      console.warn("🧩 [ENFANT] Logique de victoire validée !");
      onSolved?.();
    }
  }, [interactiveRows, onSolved]);

  const fullGrid = [
    [BASE[0], BASE[1], BASE[2], BASE[3]], // Ligne 1 fixe
    [BASE[1], BASE[2], BASE[3], BASE[0]], // Ligne 2 fixe
    interactiveRows[0],
    interactiveRows[1],
  ];

  return (
    <div className="mt-3 flex flex-col items-center gap-3">
      <div className="grid grid-cols-4 gap-2 mt-2">
        {fullGrid.map((row, r) =>
          row.map((symbol, c) => (
            <button
              key={`${r}-${c}`}
              onClick={() => handleClickCell(r, c)}
              className={[
                "w-12 h-12 rounded-lg flex items-center justify-center text-2xl shadow-md transition",
                r < 2 ? "bg-slate-800/60 text-slate-200 cursor-default" : "bg-amber-200 text-black hover:bg-amber-100",
              ].join(" ")}
            >
              {symbol}
            </button>
          ))
        )}
      </div>
    </div>
  );
}